import { useEffect, useRef } from "react";
import FormCreator from "../../../components/forms/FormCreator";
import SearchFilterFormData from "./dataFile/SearchFilterForm.data";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useLazyGetAllProjectTypeDropdownQuery } from "../../../app/services/FieldManagement/EmailTemplateManagement/EmailTemplateManagementApi";
import { setAllDropDownFieldsBatch } from "../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import Label from "../../../components/forms/ui/label/Label";
import Buttons from "../../../components/ui/button/Buttons";
import Input from "../../../components/forms/ui/inputs/input/Input";

const SearchFilterForm = ({ getEmailList }) => {
  const SearchFilterFormRef = useRef();
  const navigate = useNavigate();
  const [searchRequest, setSearchRequest] = useState({
    ProjectTypeId: null,
    SearchText: null,
  });

  const [
    getAllProjectTypeDropdown,
    {
      isSuccess: isSuccessDropdown,
      isFetching: isFetchingDropdown,
      data: dropdownResponseData,
    },
  ] = useLazyGetAllProjectTypeDropdownQuery();

  useEffect(() => {
    getAllProjectTypeDropdown();
  }, []);

  useEffect(() => {
    if (!isFetchingDropdown && isSuccessDropdown && dropdownResponseData) {
      const field = SearchFilterFormData.section[0].rowGroup[0].fields.find(
        (field) => field.id === "ProjectTypeId"
      );
      field.fieldSetting.options = dropdownResponseData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }));
      setAllDropDownFieldsBatch(SearchFilterFormData, dropdownResponseData);
    }
  }, [isFetchingDropdown, isSuccessDropdown, dropdownResponseData]);

  const onDropDownChange = (data) => {
    let temp = { ...searchRequest };
    temp["ProjectTypeId"] = data?.ProjectTypeId?.value || null;
    setSearchRequest(temp);
    getEmailList(temp);
  };
  const handleaAddNew = () => {
    navigate("/emailTemplateManagement/addEmailTemplate");
  };

  const handleInputChange = (value) => {
    let inputValue = value;
    let temp = { ...searchRequest };
    temp["SearchText"] = inputValue;
    setSearchRequest(temp);
    getEmailList(temp);
  };

  return (
    <>
      <div>
        {dropdownResponseData && (
          <div className="row">
            <FormCreator
              config={SearchFilterFormData}
              ref={SearchFilterFormRef}
              onFormDataChange={onDropDownChange}
            ></FormCreator>
          </div>
        )}
        <div className="d-flex flex-wrap justify-content-end gap-4 mb-001">
          <div className="flex-center gap-3">
            <div className="label">
              <Label labelName="Search:" />
            </div>
            <div className="">
              <Input
                id="searchText"
                name="SearchText"
                value={searchRequest.SearchText}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div>
            <Buttons
              buttonText="+ Add New"
              buttonTypeClassName="theme-btn"
              onClick={() => handleaAddNew()}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default SearchFilterForm;
